<ng-container *transloco="let t; prefix: 'header'">
    <div class="container d-flex justify-content-center align-items-center">
        <div class="w-100 py-4" style="max-width: 50rem;">
            <breadcrumb [items]='[
                { label: t("frontpage"), route: "/" }, { label: t("cookiesandprivacy") } ]'>
            </breadcrumb>
            <h2>{{ t("cookiesandprivacy") }}</h2>
            <div class="card hover-card mb-3" (click)="goToCookiePolicy()" (keyup.enter)="goToCookiePolicy()" tabindex="0">
                <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col me-auto">
                            <h4 class="m-0">Cookiepolitik</h4>
                        </div>
                        <div class="col-auto">
                            <svg class="icon-lg icon-primary">
                                <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card hover-card" (click)="goToPrivacyPolicy()" (keyup.enter)="goToPrivacyPolicy()" tabindex="0" aria>
              <div class="card-body">
                    <div class="row align-items-center">
                        <div class="col me-auto">
                            <h4 class="m-0">Privatlivspolitik</h4>
                        </div>
                        <div class="col-auto">
                            <svg class="icon-lg icon-primary">
                                <use xlink:href="assets/icons.svg#icon-chevron-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>